import { CardHeading } from "@/pages/Dashboard/styled";
import Card from "../Card";
import * as Styled from "./styled";
import { useMediaQuery } from "@/hooks/useMatchMedia";
import useApi from "@/contexts/ApiContext";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "../LoadingScreen/styled";
import ErrorScreen from "../ErrorScreen";
import type { ReactNode } from "react";

const ContactCardWrapper = ({ children }: { children: ReactNode }) => (
  <Card gridColumn="1 / -1">
    <CardHeading>Key contacts</CardHeading>
    <Styled.ContactCard>{children}</Styled.ContactCard>
  </Card>
);

const ContactCard = () => {
  const api = useApi();
  const isDesktop = useMediaQuery("medium");

  const {
    data: keyContacts,
    isPending,
    isError,
  } = useQuery({
    queryKey: ["get-key-contacts"],
    queryFn: () => api.keyContacts.get(),
    throwOnError: false, // We have a custom error for this (below)
});

  if (isPending) {
    return (
      <ContactCardWrapper>
        <Spinner />
      </ContactCardWrapper>
    );
  }

  if (isError) {
    return (
      <ContactCardWrapper>
        <ErrorScreen withoutPage />
      </ContactCardWrapper>
    );
  }

  if (!keyContacts || keyContacts.length === 0) {
    return null;
  }

  return (
    <Card gridColumn="1 / -1">
      <CardHeading>Key contacts</CardHeading>
      <Styled.ContactCard>
        {keyContacts.map((contact) => (
          <Card
            key={contact.email}
            featureBackground={{ full: true, gradient: "light2" }}
          >
            <Styled.Wrapper>
              {isDesktop && contact.thumbnail && (
                <Styled.Thumbnail src={contact.thumbnail} alt="" />
              )}
              <Styled.Details>
                <strong>{contact.job_title}</strong>
                <div>
                  {contact.name}
                  {" - "}
                  <Styled.Email href={`mailto:${contact.email}`}>
                    {contact.email}
                  </Styled.Email>
                </div>
              </Styled.Details>
            </Styled.Wrapper>
          </Card>
        ))}
      </Styled.ContactCard>
    </Card>
  );
};

export default ContactCard;
